import Router_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Router_light.svg'
import Antenna_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Antenna_light.svg'
import Browser_light from '@tdcerhverv/parrotfish/dist/icons/Icons/Browser_light.svg'
import { IContent } from './types'

const content: IContent = {
  title: 'Driftsinformation',
  contactText: 'Oplever du driftsproblemer som endnu ikke findes på denne side, så er du velkommen til at',
  contactTextUnderline: 'kontakte os',
  subtitles: {
    bredbaand: 'for internet',
    telefoni: 'for telefoni & mobilt bredbånd',
    apps: '',
  },
  daekningsKortDescriptionDesktop:
    'Klik på "drift" i den hvide kasse i top højre hjørne af kortet, for at se om der er fejl i dit område.',
  daekningsKortDescriptionMobile:
    'Åben menuen i venstre side af kortet og klik på "drift" for at se om der er fejl i dit område',
  daekningsKortLabels: [
    {
      label: 'Aktuelle fejl',
      color: 'orange',
    },
    {
      label: 'Løste fejl',
      color: 'lightgreen',
    },
    {
      label: 'Planlagt arbejde',
      color: 'lightblue',
    },
  ],
  cards: [
    {
      icon: Router_light,
      headline: 'Internet',
      content:
        'Er der noget galt med internettet på min adresse? Er der planlagt afbrydelser som vil påvirke min forbindelse?',
      link: 'bredbaand',
    },
    {
      icon: Antenna_light,
      headline: 'Telefoni & Mobilt bredbånd',
      content:
        'Er der noget galt med mobilmasten i dit område eller har du behov for at vide om der er 5G dækning i dit område?',
      link: 'telefoni',
    },
  ],
  outageMobileAndBroadbandLink: {
    label: 'Se driftsinformationer for telefoni & mobilt bredbånd ved at klikke her',
  },
  outageHelpLinksHeadline: 'Har du stadig brug for hjælp?',
  outageHelpLinks: [
    {
      label: 'Se hjælpeartikler vedrørende Internet',
      target: '/kundeservice/internet',
    },
    {
      label: 'Tag en hastighedstest',
      target: '/hastighedstest/',
    },
    {
      label: 'Kontakt os hvis du stadig har spørgsmål',
      target: '/kundeservice/kontakt/',
    },
  ],
  outageHelpLinksForMobile: [
    {
      label: 'Se hjælpeartikler vedrørende Mobil',
      target: '/kundeservice/mobil',
    },
    {
      label: 'Se hjælpeartikler vedrørende Mobilt Bredbånd',
      target: '/kundeservice/mobilt-bredband',
    },
    {
      label: 'Kontakt os hvis du stadig har spørgsmål',
      target: '/kundeservice/kontakt/',
    },
  ],
}

export default content
